
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { CTASection } from "@/sections/CTASection";
import { TestimonialsSection } from "@/sections/TestimonialsSection";
import { FaqSection } from "@/sections/FaqSection";
import { CustomersLogosSection } from "@/sections/CustomersLogosSection";
import { PricingSectionWithTabs } from "@/sections/PricingSectionWithTabs";
import { GetServerSideProps } from "next";
import { withSession } from "@/utils/session";

type IPricing = {
  figmaAccessToken: string;
};

const Pricing = ({ figmaAccessToken }: IPricing) => {
  const { t } = useTranslation();

  return (
    <>
      <Head
        pageNamespace="page/pricing"
        ogImage="/images/pricing-og-image.jpg"
      />

      <PricingSectionWithTabs figmaAccessToken={figmaAccessToken} />

      <TestimonialsSection />

      <FaqSection />

      <CustomersLogosSection />

      <CTASection title={t("section/cta:titles.pricingPage")} href="/" />
    </>
  );
};

export default Pricing;

 const _getServerSideProps: GetServerSideProps = withSession(
  async context => {
    const code = context.req.session.get("figmaAccessToken");

    return {
      props: {
        figmaAccessToken: code || null,
      },
    };
  },
);


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/pricing',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  